module.exports = __webpack_public_path__ + "static/media/promo_musica_erudita.f957847a.webp";